<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <cobranza-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import CobranzaShowData from "./CobranzaShowDataCustom";
    import {CrudShow} from '@dracul/common-frontend'

    export default {
        name: "CobranzaShow",
        components: {CrudShow, CobranzaShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'cobrox.cobranza.showing',
            }
        },
    }
</script>

